import React, { useEffect, useState, useRef } from 'react';
import classes from './Payment.module.scss';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { Buttons } from '../../../components/Buttons';
import { SuccessMessage } from '../../../components/Message/SuccessMessage';
import config from '../../../constants/config';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import LoadingOverlay from 'react-loading-overlay';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { Stack, Checkbox, Table, TableRow, TableBody, TableCell } from '@mui/material';
import { CloseableAlerts } from '../../../components/Message/CloseableAlerts';
import { useDispatch } from 'react-redux';
import validator from '../../../helpers/checkValidations';
import CardForm from './components/CardForm.jsx';
import ACHForm from '../../../components/ACHForm/ACHForm';
import PrivacyStatement from './components/PrivacyStatement';
import CustomerForm from './components/CustomerForm';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { checkAddressEnabled } from '../../../helpers/functions/addressFieldsEnabled';
import AddressFieldsDropDown from '../../../components/AddressFieldsDropDown/AddressFieldsDropDown';
import { getLocationSettingsByLocId } from '../../../actions/LocationAction';
import { getCardInfoViaBinLookup } from '../../../helpers/functions/checkCardType';
import { getCustomInvoiceName } from '../../../helpers/commonFunction';
import Topheader from '../../../components/Topheader/Topheader.js';
import { whichLocationSelected } from '../../../helpers/getLocationFromLocalStorage.js';
import { CustomerDetailsId } from '../../../actions/CustomerAction.js';
import PaymentConfirmation from '../../Payment/components/PaymentConfirmation.jsx';
import { DataGetApiV2, DataPostApiV2 } from '../../../helpers/PostDataApi';
import SelectAccount from '../../../components/SelectAccount/SelectAccount';
import commonStrings from '../../../constants/commonStrings';
import transactionsService from '../../../services/customerPortalService';
import { AlertSeverityTypes, FlexAlerts } from '../../../components/Message/Alerts/Alerts';
import FeeDisplay from '../../../components/FeeDisplay/FeeDisplay.jsx';

const QuickPay = () => {
  const loc = whichLocationSelected();
  const locationId = loc.id;

  //QuickPay Component States
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState('card');
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState({});
  const [savedPaymentMethods, setSavedPaymentMethods] = useState([]);
  const [misMatchError, setMisMatchError] = useState([]);
  const [successMessage, setSuccessMessage] = useState([]);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [isMultipassSubmitDisabled, setIsMultipassSubmitDisabled] = useState(true);
  const [location, setLocation] = useState({});
  const [paytraceCredentials, setPaytraceCredentials] = useState({
    paytraceKey: '',
    userName: '',
    password: '',
  });
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState({
    //#Customer Errors
    firstNameError: false,
    lastNameError: false,
    emailError: false,
    amountError: false,
    invoiceError: false,
    //#CardForm Errors
    cardNumberError: false,
    cardExpiryDateError: false,
    cardCscError: false,
    billingAddressError: false,
    shippingAddressError: false,
    zipError: false,
  });
  const [messages, setMessages] = useState([]);
  const [locationSettings, setLocationSettings] = useState({});
  const [termsAndCondition, setTermsAndConditions] = useState({});
  const initialAddressFields = {
    addressOne: '',
    addressTwo: '',
    state: '',
    zip: '',
    city: '',
  };
  const [billingAddress, setBillingAddress] = useState(initialAddressFields);
  const [shippingAddress, setShippingAddress] = useState(initialAddressFields);
  const [paymentType, setPaymentType] = useState(commonStrings.debit);

  //ACHForm States
  const [ach, setAch] = useState({
    isOpen: false,
    isSaveChecked: false,
    accountName: '',
    accountNumber: '',
    routingNumber: '',
  });

  //CardForm states
  const [card, setCard] = useState({
    isOpen: false,
    cardNumber: '_______________',
    cardExpiryDate: '__/____',
    cardCsc: '___',
    customerToken: false,
    customerTokenUpdate: false,
    encryptedNumber: '',
    encryptedCsc: '',
    cardType: '',
  });

  const [americanExpress, setAmericanExpress] = useState(false);

  //CustomerForm States
  const [customerData, setCustomerData] = useState({});

  //PaymentDetails States
  const [invoice, setInvoice] = useState('');
  const [baseAmount, setBaseAmount] = useState('');
  const [calculationResult, setCalculationResult] = useState({});
  const [isStoredCard, setIsStoredCard] = useState(false);
  const dispatch = useDispatch();
  const [paymentResponse, setPaymentResponse] = useState('');
  const [binCodesResponse, setBinCodesResponse] = useState({});
  const [maskedCardNumber, setMaskedCardNumber] = useState('');
  const achFormValidationRef = useRef(null);

  useEffect(() => {
    setIsLoading(true);
    Promise.all([dispatch(getLocationSettingsByLocId(locationId))])
      .then((results) => {
        const locationSettingsResponse = results[0].payload.locationData.data.response;
        setLocation(locationSettingsResponse.location);
        if (locationSettingsResponse.location?.gateway == 'multipass') {
          setIsSubmitDisabled(true);
        }
        setLocationSettings(locationSettingsResponse.settings);
        setTermsAndConditions(locationSettingsResponse.termsAndConditions);
        setPaytraceCredentials({
          paytraceKey: locationSettingsResponse.location.paytraceKey,
          userName: locationSettingsResponse.location.paytraceUserName,
          password: locationSettingsResponse.location.paytracePassword,
        });
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setIsLoading(false);
      });
    getCustomerDetails();
  }, [locationId]);

  // Constants for Card / Bank Transfer radio toggle
  const radioOptions = { card: 'card', bankTransfer: 'bankTransfer' };

  const getPaymentVault = () => {
    if (location?.ACHPaymentVault) {
      if (customerData?._id) {
        const query = {
          customerId: customerData._id,
        };

        DataGetApiV2(config.BASEURL + 'getPaymentVault', query)
          .then((response) => {
            if (response.data?.paymentMethods) {
              setSavedPaymentMethods(response.data.paymentMethods);
            }
          })
          .catch((_error) => {
            const misMatchError = ['Could not get account data.'];
            setMisMatchError(misMatchError);
            setSelectedPaymentMethod({});
          });
      } else {
        setAch({
          isOpen: false,
          isSaveChecked: false,
          accountName: '',
          accountNumber: '',
          routingNumber: '',
        });
        setSelectedPaymentMethod({});
        setSavedPaymentMethods([]);
      }
    }
  };

  useEffect(() => {
    getPaymentVault();
  }, [location?.ACHPaymentVault, customerData._id]);

  useEffect(() => {
    if (paytraceCredentials?.paytraceKey) {
      const localUrl = config.BASEURL + 'getPemFile?fileName=';
      window.paytrace.setKeyAjax(localUrl + paytraceCredentials?.paytraceKey);
    }
  }, [paytraceCredentials]);

  useEffect(() => {
    /*
      since multipass card tokenized information is set in state from with in the child component therefore
      card object doesn't have a plain card number here but a tsep token that's why card number is not lookedup with 
      a binlook up for multipass here as it is already done with in the cardForm component for multipass
    */
    if (
      location?.gateway !== 'multipass' &&
      (!card.cardNumber.slice(0, 6).includes('_') || card.cardNumber.replace(/_/g, '').length >= 6)
    ) {
      try {
        getCardInfoViaBinLookup(card.cardNumber).then((cardInfo) => {
          setBinCodesResponse(cardInfo?.data);
          setPaymentType(cardInfo?.data?.type);
          setCard((prevState) => ({
            ...prevState,
            cardType: cardInfo?.data?.card,
          }));
        });
      } catch (e) {
        console.log('Error', e);
      }
    }
  }, [card.cardNumber]);

  const getCustomerDetails = async () => {
    const userDetails = JSON.parse(localStorage.getItem('user'));
    dispatch(CustomerDetailsId({ id: userDetails.customerId ?? process.env.CUSTOMER_TEMP_ID })).then((result) => {
      if (result.payload.customerData.data.statusCode === 200) {
        const { firstName, lastName, masked_card_number } = result.payload.customerData.data.response;
        setCustomerData({ ...result.payload.customerData.data.response, name: `${firstName} ${lastName}` });
        setBillingAddress(result.payload.customerData.data.response.billingAddress);
        setShippingAddress(result.payload.customerData.data.response.shippingAddress);
        setPaymentType(result.payload.customerData.data.response?.creditOrDebit);
        if (masked_card_number && masked_card_number !== '') {
          setIsStoredCard(true);
          setIsMultipassSubmitDisabled(false);
        }
      }
    });
  };

  const handleAddressChange = (event, type, isBillingAddressSameAsShippingAddress = false) => {
    let errors = { ...error };
    let misMatchErrors = [];
    let { id, value } = event.target;

    if (type === 'billingAddress') {
      setBillingAddress((prevInfo) => ({
        ...prevInfo,
        [id]: value,
      }));
    }
    if (type === 'shippingAddress' || isBillingAddressSameAsShippingAddress) {
      setShippingAddress((prevInfo) => ({
        ...prevInfo,
        [id]: value,
      }));
    }
    setError(errors);
    setMisMatchError(misMatchErrors);
    setIsSubmitDisabled(false);
  };

  const handleIsBillingAddressSameAsShippingAddress = (isBillingAddressSameAsShippingAddress = false) => {
    if (isBillingAddressSameAsShippingAddress) {
      setShippingAddress((prevInfo) => ({
        ...prevInfo,
        ...billingAddress,
      }));
    } else {
      setShippingAddress(initialAddressFields);
    }
  };
  const handleChangeOption = (event) => {
    const option = event.target.value;
    if (option === radioOptions.bankTransfer) {
      setPaymentType(commonStrings.ach);
      setIsMultipassSubmitDisabled(false);
    } else {
      setPaymentType(isStoredCard ? customerData?.creditOrDebit : commonStrings.debit);
      setIsMultipassSubmitDisabled(!isStoredCard);
    }
    setSelectedOption(option);
  };

  const handleChangeCustomerEmail = (event) => {
    let { id, value } = event.target;
    let errors = {};
    if (value !== '' && value !== null && value !== undefined) {
      errors[id + 'Error'] = validator(id, value);
      setError(errors);
    }
    setCustomerData({
      ...customerData,
      email: value,
    });
  };
  const handleChangeCustomer = (event) => {
    let errors = { ...error };
    let { id, value } = event.target;
    errors[id + 'Error'] = validator(id, value);
  };
  const handleChangeACH = (event) => {
    let errors = { ...error };
    let misMatchErrors = [];
    let { id, value } = event.target;
    errors[id + 'Error'] = validator(id, value);

    setAch((prevAch) => ({
      ...prevAch,
      [id]: value,
      isOpen: selectedOption === radioOptions.bankTransfer,
    }));
    setError(errors);
    setMisMatchError(misMatchErrors);
    setIsSubmitDisabled(false);
    setIsMultipassSubmitDisabled(false);
  };

  const handleChangeCard = (event) => {
    let errors = { ...error };
    let misMatchError = [];
    const cardFormFields = ['cardNumber', 'cardExpiryDate', 'cardCsc'];

    let { id, value } = event.target;
    errors[id + 'Error'] = validator(id, value);

    if (cardFormFields.includes(id)) {
      if (id === 'cardNumber') {
        if (value[0] === '3' && value.length === 16 && value[value.length - 1] === '_') {
          value = value.slice(0, -1);
        }
        if (value.length >= 15 && value[value.length - 1] !== '_') {
          setMaskedCardNumber(value.slice(-4));
        }
      }
      setCard((prevCard) => ({
        ...prevCard,
        [id]: value,
        customerToken: true,
        isOpen: selectedOption === radioOptions.card,
      }));
      let firstNumber = card.cardNumber;
      if (firstNumber[0] === '3') {
        setAmericanExpress(true);
      } else {
        setAmericanExpress(false);
      }
    }
    setError(errors);
    setMisMatchError(misMatchError);
    setIsSubmitDisabled(false);
  };
  const removeCloseableMessage = (index) => {
    setMisMatchError((prevMisMatchError) => {
      return prevMisMatchError.filter((_, i) => i !== index);
    });
  };
  const checkCardValues = () => {
    if (selectedOption !== radioOptions.card) {
      return true;
    }
    if (isStoredCard) {
      return true;
    }
    const updatedMisMatchError = [];
    if (card.cardNumber.indexOf('_') > -1 || card.cardNumber === '') {
      setError((prevErrorCard) => ({ ...prevErrorCard, cardNumberError: true }));
      updatedMisMatchError.push('Enter Card Number');
    }
    if (card.cardExpiryDate.indexOf('_') > -1 || card.cardExpiryDate === '') {
      setError((prevErrorCard) => ({ ...prevErrorCard, cardExpiryDateError: true }));
      updatedMisMatchError.push('Enter Card Expiry Date');
    }
    if (card.cardCsc.indexOf('_') > -1 || card.cardCsc === '') {
      setError((prevErrorCard) => ({ ...prevErrorCard, cardCscError: true }));
      updatedMisMatchError.push('Enter CVV');
    }
    if (updatedMisMatchError.length > 0) {
      setMisMatchError(updatedMisMatchError);
      return false;
    }
    return true;
  };

  const checkCustomerFormValues = () => {
    let updatedMisMatchError = [];
    if (isNaN(baseAmount) || baseAmount === 0) {
      setError((prevError) => ({ ...prevError, amount: true }));
      updatedMisMatchError.push('Enter Amount');
    } else {
      setError((prevError) => ({ ...prevError, amount: false }));
      setMisMatchError([]);
    }
    if (customerData.firstName === '') {
      setError((prevError) => ({ ...prevError, firstNameError: true }));
      updatedMisMatchError.push('Enter First Name');
    } else {
      setError((prevError) => ({ ...prevError, firstNameError: false }));
      setMisMatchError([]);
    }
    if (customerData.email === '' || validator('email', customerData.email)) {
      setError((prevError) => ({ ...prevError, firstNameError: true }));
      updatedMisMatchError.push('Enter Valid Email');
    } else {
      setError((prevError) => ({ ...prevError, firstNameError: false }));
      setMisMatchError([]);
    }
    if (invoice === '') {
      setError((prevError) => ({ ...prevError, invoiceError: true }));
      updatedMisMatchError.push('Enter Invoice Number');
    } else {
      setError((prevError) => ({ ...prevError, invoiceError: false }));
      setMisMatchError([]);
    }
    if (updatedMisMatchError.length > 0) {
      setMisMatchError(updatedMisMatchError);
      return false;
    } else {
      return true;
    }
  };

  const checkBillingAndShippingAddress = () => {
    let updatedMisMatchError = [];
    const checkRequiredField = (settings, address, errorKey, errorMessage) => {
      if (settings && address === '') {
        setError((prevError) => ({ ...prevError, [errorKey]: true }));
        updatedMisMatchError.push(errorMessage);
      }
    };
    const billingSettings = locationSettings?.invoiceSettings?.billingAddress;
    const shippingSettings = locationSettings?.invoiceSettings?.shippingAddress;

    if (billingSettings?.isBillingAddressRequired) {
      checkRequiredField(
        billingSettings.addressOne,
        billingAddress.addressOne,
        'billingAddressError',
        'Billing Address: Address One is Required'
      );
      checkRequiredField(
        billingSettings.addressTwo,
        billingAddress.addressTwo,
        'billingAddressError',
        'Billing Address: Address Two is Required'
      );
      checkRequiredField(
        billingSettings.city,
        billingAddress.city,
        'billingAddressError',
        'Billing Address: City is Required'
      );
      checkRequiredField(
        billingSettings.state,
        billingAddress.state,
        'billingAddressError',
        'Billing Address: State is Required'
      );
      if (billingSettings.isZipRequired) {
        checkRequiredField(
          billingSettings.zip,
          billingAddress.zip,
          'billingAddressError',
          'Billing Address: Zip is Required'
        );
      }
    }
    if (shippingSettings?.isShippingAddressRequired) {
      checkRequiredField(
        shippingSettings.addressOne,
        shippingAddress.addressOne,
        'shippingAddressError',
        'Shipping Address: Address One is Required'
      );
      checkRequiredField(
        shippingSettings.addressTwo,
        shippingAddress.addressTwo,
        'shippingAddressError',
        'Shipping Address: Address Two is Required'
      );
      checkRequiredField(
        shippingSettings.city,
        shippingAddress.city,
        'shippingAddressError',
        'Shipping Address: City is Required'
      );
      checkRequiredField(
        shippingSettings.state,
        shippingAddress.state,
        'shippingAddressError',
        'Shipping Address: State is Required'
      );
      if (shippingSettings.isZipRequired) {
        checkRequiredField(
          shippingSettings.zip,
          shippingAddress.zip,
          'shippingAddressError',
          'Shipping Address: Zip is Required'
        );
      }
    }
    if (updatedMisMatchError.length > 0) {
      setMisMatchError(updatedMisMatchError);
      return false;
    } else {
      return true;
    }
  };

  const checkIsValid = () => {
    let isValid = true;

    if (paymentType === 'ACH') {
      isValid = achFormValidationRef.current && achFormValidationRef.current.validate();
    }

    return isValid;
  };

  const handleSelectAccountACH = (selectedAccountDetails) => {
    if (selectedAccountDetails) {
      let accountDetails = {
        ...selectedAccountDetails,
        accountNumber: selectedAccountDetails.maskedValue,
      };
      setAch({ ...ach, ...accountDetails });
      setSelectedPaymentMethod(accountDetails);
    } else {
      // if removing selected account
      setAch({
        isOpen: true,
        accountName: '',
        accountNumber: '',
        routingNumber: '',
      });
      setSelectedPaymentMethod({});
    }
  };

  const handleCheckSaveACHAccount = (isChecked) => {
    // only change check if payment method not selected
    if (!selectedPaymentMethod.paymentMethodId?.length > 0) {
      setAch({ ...ach, isSaveChecked: isChecked });
    }
  };

  const canAddAccount = () => {
    let canAddAccount = true;
    if (location.gateway === commonStrings.paytrace) {
      canAddAccount =
        savedPaymentMethods?.filter((method) => method.paymentType?.toLowerCase() === commonStrings.ach).length === 0;
    }
    return canAddAccount;
  };

  /**
   * @description - Maps legacy stored card payment to Payment Vault transaction
   * @returns {Object} Mapped Payment Method
   */
  const mapLegacyStoredCardToPaymentVaultPaymentMethod = () => {
    const locationPayDetails = JSON.parse(localStorage.getItem('locationPaydetails')) || {};
    const gateway = locationPayDetails?.gateway || '';

    const paymentMethod = {
      paymentType: customerData.creditOrDebit?.toLowerCase(),
      customerId: customerData._id,
      gatewayPaymentMethodId: null,
      binCodesResponse: customerData.binCodesResponse,
      cardNetwork: customerData.cardType,
      maskedAccountNumber: customerData.masked_card_number,
    };

    if (gateway.toLowerCase() === commonStrings.multipass.toLowerCase()) {
      paymentMethod.gatewayPaymentMethodId = customerData.cardWalletID;
    } else if (gateway.toLowerCase() === commonStrings.paytrace.toLowerCase()) {
      paymentMethod.gatewayPaymentMethodId = customerData.customer_id;
    }
    return paymentMethod;
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    const isValid =
      checkCustomerFormValues() && checkCardValues() && checkBillingAndShippingAddress() && checkIsValid();
    if (!isValid) {
      setIsSubmitDisabled(false);
      window.scrollTo(0, 0);
      return;
    }

    setIsLoading(true);
    setIsSubmitDisabled(true);
    if (location?.gateway !== 'multipass') {
      window.paytrace.submitEncrypted('#DemoForm');
    }

    // Spike to Investigate the mechanism by which encrypted card values are being stored - https://titaniumflex.atlassian.net/browse/WI10-4934
    const encryptedNumber = !isStoredCard ? localStorage.getItem('0') : null;
    const encryptedCSC = !isStoredCard ? localStorage.getItem('1') : null;

    if (location.ACHPaymentVault && ach.isSaveChecked) {
      if (customerData?._id) {
        const query = {
          customerId: customerData?._id,
        };
        const payload = { ach };

        DataPostApiV2(config.BASEURL + 'addPaymentMethodToVault', payload, query)
          .then((response) => {
            let newAccount = { ...response.data };
            setSavedPaymentMethods([...savedPaymentMethods, newAccount]);
            getPaymentVault();
          })
          .catch((error) => {
            const misMatchError = [error?.response?.data?.message ?? 'Could not add account.'];
            setMisMatchError(misMatchError);
            return false;
          });
      }
    }

    let paymentMethod = null;
    // Payment Vault ACH payment
    if (selectedOption === radioOptions.bankTransfer && selectedPaymentMethod?.paymentMethodId) {
      // IF payment method is selected, iterate through saved payment methods and select the ID of the matching Payment Method
      savedPaymentMethods.forEach((pm) => {
        if (selectedPaymentMethod?.paymentMethodId === pm?.paymentMethodId) {
          paymentMethod = pm;
          paymentMethod = {
            paymentType: commonStrings?.ach,
            paymentMethodId: pm.paymentMethodId,
            maskedAccountNumber: pm.maskedValue,
            accountName: pm.accountName,
            accountType: pm.accountType,
            bankName: pm.bankName,
          };
        }
      });
      if (!paymentMethod)
        console.error({
          message: "Selected Payment Method ID does not have a corresponding item in customer's Payment Vault",
        });
    }

    // One time ACH payment
    if (selectedOption === radioOptions.bankTransfer && !selectedPaymentMethod?.paymentMethodId) {
      paymentMethod = {};
      paymentMethod.paymentType = commonStrings.ach;
      paymentMethod.accountNumber = ach?.accountNumber;
      paymentMethod.routingNumber = ach?.routingNumber;
      paymentMethod.accountName = ach?.accountName;
      paymentMethod.accountType = ach?.bankAccountType;
      paymentMethod.bankName = ach?.bankName;
      paymentMethod.maskedAccountNumber = ach?.accountNumber?.slice(-4);
    }

    // One time card payment
    if (selectedOption === radioOptions.card && !isStoredCard) {
      paymentMethod = {};
      paymentMethod.accountName =
        customerData.name || `${customerData.firstName || ''} ${customerData.lastName || ''}`.trim();
      paymentMethod.encryptedCSC = encryptedCSC?.trim();
      paymentMethod.encryptedCard = encryptedNumber;
      paymentMethod.expirationDate = card.isOpen ? card.cardExpiryDate : '';
      paymentMethod.cardNetwork = binCodesResponse?.card || card.cardType;
      paymentMethod.binCodesResponse = binCodesResponse || {};
      paymentMethod.paymentType = binCodesResponse?.type?.toLowerCase();
      paymentMethod.maskedAccountNumber = maskedCardNumber;
    }

    // Legacy Implementation of a stored card being mapped to a payment vault transaction payload
    if (selectedOption === radioOptions.card && isStoredCard) {
      paymentMethod = mapLegacyStoredCardToPaymentVaultPaymentMethod();
    }

    const data = {
      source: 'Quick Pay',
      baseAmount,
      orderId: invoice,
      paymentMethod,
      billingAddress,
      shippingAddress,
    };

    const customerId = customerData._id ?? '';
    transactionsService
      .runCustomerPortalTransaction(customerId, data)
      .then((res) => {
        setSuccess(true);
        setPaymentResponse({
          transactionId: res?.data?.data?.transactionId,
          date: new Date(),
          maskCard: res?.data?.data?.maskedAccountNumber || customerData.masked_card_number,
        });
        setIsLoading(false);
        setSuccessMessage(res?.data?.message);
      })
      .catch((e) => {
        const misMatchError = [];
        let message = e?.response?.data?.message;
        misMatchError.push(message);
        setMisMatchError(misMatchError);
        setSuccess(false);
        setIsLoading(false);
        setIsSubmitDisabled(false);
        setIsMultipassSubmitDisabled(false);
        setSuccessMessage([]);
        setPaymentResponse({});
      });
  };

  const getBannerText = () => {
    return <p className={classes.bannerText}>{termsAndCondition?.selfPaymentBanner}</p>;
  };
  const handleCard = () => {
    setIsStoredCard(false);
    setIsMultipassSubmitDisabled(true);
    setPaymentType(commonStrings.debit);
  };

  return (
    <div className="rightPanel">
      <Topheader />
      <div className="contentPart"></div>
      <Container component="main" maxWidth="xl" className="desktopPage">
        {success ? <SuccessMessage successes={[successMessage]} /> : ''}
        <div className="min-wrap pay-page desktopPage">
          <Stack sx={{ width: '100%' }} spacing={2}>
            {misMatchError.map((e, id) => (
              <CloseableAlerts
                key={id}
                index={id}
                message={e}
                severity="error"
                closer={removeCloseableMessage}
                sx={{ width: '100%', marginBottom: 2 }}
              />
            ))}
            <FlexAlerts messages={messages} />
          </Stack>
          <LoadingOverlay className={classes.tpTableFullW} active={isLoading} spinner text="Fetching your response ...">
            {success ? (
              <PaymentConfirmation
                invoice={invoice}
                locationSettings={{
                  ...locationSettings.virtualTerminalSettings,
                  DualFeeEnabled: calculationResult?.options?.dualPricing,
                }}
                customerData={customerData}
                amount={calculationResult?.baseAmount}
                total={calculationResult?.totalAmount}
                fees={{
                  svcFee: calculationResult?.fees?.cardUpcharge?.amount,
                  surcharge: calculationResult?.fees?.surcharge?.amount,
                  tax: calculationResult?.fees?.tax?.amount,
                }}
                selectedOption={selectedOption}
                card={
                  isStoredCard
                    ? {
                        masked_card_number: customerData.masked_card_number,
                        cardType: card.cardType || customerData.cardType,
                      }
                    : card
                }
                paymentType={paymentType}
                location={{
                  locationName: location?.locationName,
                  customInvoiceName: getCustomInvoiceName(location),
                  image: location.image,
                }}
                ach={ach}
                paymentResponse={paymentResponse}
              />
            ) : (
              <>
                <Grid container spacing={3} justifyContent="center">
                  <Grid item md={8} lg={6}>
                    <div style={{ marginLeft: '23px', marginTop: '-30px', marginBottom: '10px' }}>
                      <h3 className="terminal-title">Make a quick payment</h3>
                    </div>
                    <Card>
                      <CardContent>
                        <div className="terminal-inner">
                          <Grid container className="terminal-title-grid" spacing={3} alignItems="center">
                            {termsAndCondition?.isSelfPaymentPageBannerEnabled && (
                              <Grid item sm={12}>
                                <div className="borderd">{getBannerText()}</div>
                              </Grid>
                            )}
                          </Grid>
                          <form className={classes.form} id="DemoForm">
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={12} md={12}>
                                <Grid container>
                                  <CustomerForm
                                    invoice={invoice}
                                    amount={baseAmount}
                                    customerData={customerData}
                                    handleChangeCustomer={handleChangeCustomer}
                                    handleChangeCustomerEmail={handleChangeCustomerEmail}
                                    handleChangeInvoice={setInvoice}
                                    handleChangeAmount={setBaseAmount}
                                    error={error}
                                  />
                                  <Grid container spacing={3} justifyContent="center">
                                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                                      <RadioGroup
                                        row
                                        aria-label="payment-options"
                                        name="payment-options"
                                        value={selectedOption}
                                        onChange={handleChangeOption}
                                      >
                                        <FormControlLabel
                                          value="card"
                                          control={<Radio color="primary" />}
                                          label="Card"
                                        />
                                        {location.ACH && (
                                          <FormControlLabel
                                            value={radioOptions.bankTransfer}
                                            control={<Radio color="primary" />}
                                            label="Bank Transfer"
                                          />
                                        )}
                                      </RadioGroup>
                                    </Grid>
                                    <Grid item xs={12} style={{ marginBottom: '10px' }}>
                                      {selectedOption === radioOptions.card && (
                                        <CardForm
                                          error={error}
                                          handleChangeCard={handleChangeCard}
                                          americanExpress={americanExpress}
                                          card={card}
                                          gateway={location?.gateway}
                                          location={location}
                                          setCard={setCard}
                                          setPaymentType={setPaymentType}
                                          setBinCodesResponse={setBinCodesResponse}
                                          setMaskedCardNumber={setMaskedCardNumber}
                                          setIsSubmit={setIsSubmitDisabled}
                                          disableMultipassSubmit={setIsMultipassSubmitDisabled}
                                          customerData={customerData}
                                          isStoredCard={isStoredCard}
                                          handleCard={handleCard}
                                        />
                                      )}
                                      {selectedOption === radioOptions.bankTransfer && (
                                        <Grid container spacing={3}>
                                          {location.ACHPaymentVault && (
                                            <Grid item xs={12} md={12}>
                                              <SelectAccount
                                                paymentMethods={savedPaymentMethods}
                                                selectAccount={(option) => {
                                                  handleSelectAccountACH(option);
                                                }}
                                                selectedAccount={selectedPaymentMethod}
                                                type={commonStrings.ach}
                                              />
                                            </Grid>
                                          )}
                                          <Grid item xs={12} md={12}>
                                            <ACHForm
                                              ach={ach}
                                              handleChangeACH={(e) => handleChangeACH(e)}
                                              location={location}
                                              ref={achFormValidationRef}
                                            />
                                          </Grid>
                                          {location.ACHPaymentVault &&
                                            customerData?._id?.length > 0 &&
                                            canAddAccount() && (
                                              <Grid item xs={12} md={12}>
                                                <FormControlLabel
                                                  label="Save bank account for future use"
                                                  control={
                                                    <Checkbox
                                                      checked={
                                                        selectedPaymentMethod?.paymentMethodId?.length > 0 ||
                                                        ach.isSaveChecked
                                                      }
                                                      onChange={(_e, value) => handleCheckSaveACHAccount(value)}
                                                      color="primary"
                                                    />
                                                  }
                                                />
                                              </Grid>
                                            )}
                                        </Grid>
                                      )}
                                    </Grid>
                                    <Grid item xs={12} style={{ marginBottom: '10px' }}>
                                      {checkAddressEnabled(locationSettings?.invoiceSettings?.billingAddress) && (
                                        <Grid item xs={12} sm={12} md={12} style={{ marginBottom: '20px' }}>
                                          <AddressFieldsDropDown
                                            type="billing"
                                            state={{
                                              addressSettings: {
                                                billingAddress: locationSettings?.invoiceSettings?.billingAddress,
                                                shippingAddress: locationSettings?.invoiceSettings?.shippingAddress,
                                              },
                                              billingAddress,
                                            }}
                                            handleChange={handleAddressChange}
                                            handleSameAddress={handleIsBillingAddressSameAsShippingAddress}
                                          />
                                        </Grid>
                                      )}
                                      {checkAddressEnabled(locationSettings?.invoiceSettings?.shippingAddress) && (
                                        <Grid item xs={12} sm={12} md={12} style={{ marginBottom: '20px' }}>
                                          <AddressFieldsDropDown
                                            type="shipping"
                                            state={{
                                              addressSettings: {
                                                billingAddress: locationSettings?.invoiceSettings?.billingAddress,
                                                shippingAddress: locationSettings?.invoiceSettings?.shippingAddress,
                                              },
                                              shippingAddress,
                                            }}
                                            handleChange={handleAddressChange}
                                            handleSameAddress={handleIsBillingAddressSameAsShippingAddress}
                                          />
                                        </Grid>
                                      )}
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item md={12} style={{ marginBottom: '20px', textAlign: 'center' }}>
                                  <Buttons
                                    startIcon={<LockOutlinedIcon />}
                                    id="signUp"
                                    type="button"
                                    fullWidth={true}
                                    variant="contained"
                                    color="primary"
                                    className={classes.payBtn}
                                    onClick={handleSubmit}
                                    disabled={
                                      location?.gateway !== 'multipass' ? isSubmitDisabled : isMultipassSubmitDisabled
                                    }
                                    text={'Pay'}
                                  />
                                </Grid>
                                <PrivacyStatement
                                  activeTab={selectedOption}
                                  locationId={location}
                                  total={calculationResult?.totalAmount}
                                  amount={baseAmount}
                                  paymentTerms={termsAndCondition}
                                  isLoading={setIsLoading}
                                />
                              </Grid>
                            </Grid>
                          </form>
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item md={4} lg={3}>
                    <Card>
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item xs={12}>
                            <Buttons
                              id="vInvoice"
                              type="button"
                              fullWidth={true}
                              className={classes.viewInvoice}
                              variant="outlined"
                              text={'Payment Details'}
                            />
                          </Grid>
                          <Grid item xs={12} className={classes.invoiceDetail}>
                            <Table className={classes.table} size="small" aria-label="a dense table">
                              <TableBody>
                                {invoice?.length > 0 && (
                                  <TableRow>
                                    <TableCell align="left">Invoice Number</TableCell>
                                    <TableCell align="right" style={{ overflowWrap: 'anywhere' }}>
                                      {invoice}
                                    </TableCell>
                                  </TableRow>
                                )}
                                <TableRow>
                                  <TableCell align="left">Customer Name</TableCell>
                                  <TableCell align="right" style={{ overflowWrap: 'anywhere' }}>
                                    {`${customerData.firstName} ${customerData.lastName}`}
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </Grid>
                          <Grid item xs={12}>
                            <FeeDisplay
                              baseAmount={baseAmount}
                              paymentType={paymentType}
                              state={billingAddress?.state}
                              setCalculationResult={(newCalculationResult) => {
                                setCalculationResult(newCalculationResult);
                              }}
                              setError={(err) => {
                                setMessages([{ severity: AlertSeverityTypes.error, message: err?.message }]);
                              }}
                            />
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </>
            )}
          </LoadingOverlay>
        </div>
      </Container>
    </div>
  );
};

export default QuickPay;
